module.exports = __webpack_public_path__ + "img/gallery10.69283e5.jpg";